import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '../../common/enums/api-status';
import { getAllExpertisesAsync } from './expertiseThunk';
const initialState = {
    status: APIStatus.IDLE,
    expertises: []
};
export const expertiseSlice = createSlice({
    name: 'expertise',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllExpertisesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllExpertisesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.expertises = action.payload;
        })
            .addCase(getAllExpertisesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default expertiseSlice.reducer;
